<template>
    <div>
        <div class="columns">
            <div class="column is-6 is-offset-3">
                <item-form :create="true" @saved="editItem"></item-form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        methods: {
            editItem(item) {
                this.$router.push({name: 'item', params: {id: item.id}})
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ItemCreate.vue?6ed6b368